<template>
  <div class="event" v-on:click="$emit('detailed-open')"
                     @mouseover="$emit('detailed-open')"
                     @mouseleave="$emit('detailed-close')">
    <div class="title">
      {{ info.title }}
    </div>
    <div :class="{'datetime': true, 'weekly-datetime':weeklyView}">{{ info.date_time }}</div>
  </div>
</template>

<script>
export default {
  name: 'Event',
  components: {
  },
  props: {
    info: { type: Object, required: true },
    weeklyView: Boolean
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.event {
  margin-bottom: 6px;
  text-align: left;
  padding: 2px 4px 2px 9px;
  /*background-color: lightblue;*/
}
.datetime {
  font-size: 13px;
  color: #00b398;
}
.weekly-datetime {
  color: #2c3e50;
}
.title {
  font-size: 15px;
  font-weight: bold;
  word-wrap: break-word;
}
.title:hover {
  cursor: pointer;
}
</style>
